





























































































import { Component, Vue } from 'vue-property-decorator';
import {
  BillableTargetAppUserMonthModel,
  TimeAccountTeamWeeklyOverviewModel,
  TimeAccountTeamWeeklyOverviewQuery,
  TimeAccountTeamWeeklyOverviewWeekModel
} from '@/services/api/nswag/stapiclient_generated';
import { stTimeAccountApi } from '@/services/st-api';
import { DateTime } from 'luxon';
import TeamOverviewApprovalEdit from '@/views/TeamOverview/TeamOverviewApprovalDay.vue';
import TeamOverviewApprovalDay from '@/views/TeamOverview/TeamOverviewApprovalDay.vue';
import { UserStore } from '@/store/user-module';
import {getHours} from '@/utlitities/helper';
import TeamOverviewTimeAccountApprovalForm from '@/views/TeamOverview/TeamOverviewTimeAccountApprovalForm.vue';

@Component({ components: {TeamOverviewTimeAccountApprovalForm, TeamOverviewApprovalDay, TeamOverviewApprovalEdit } })
export default class TeamOverviewTimeAccount extends Vue {
  loading = true;
  delayLoading = false;
  date: DateTime = UserStore.userNowDateTime;
  model: TimeAccountTeamWeeklyOverviewModel = TimeAccountTeamWeeklyOverviewModel.fromJS({});

  get dateTo(): DateTime {
    return this.date.plus({ days: 8 * 7 });
  }

  async changeWeek(plusminus: number) {
    this.date = this.date.plus({ days: plusminus * 7 });
    await this.loadData();
  }

  async mounted() {
    await this.loadData();
  }

  async loadData() {
    try {
      this.delayLoading = true;
      this.loading = true;
      const query = TimeAccountTeamWeeklyOverviewQuery.fromJS({});
      query.date = this.date.toFormat('yyyy-MM-dd');
      this.model = await stTimeAccountApi.getTimeAccountTeamWeeklyOverview(query);
    } finally {
      this.delayLoading = false;
      this.loading = false;
    }
  }
}
